export class CatalogFilter<T> {
  public useFilter: boolean;
  public filterKey: T;
  constructor(filterKey:T) {
    this.useFilter = false;
    this.filterKey = filterKey;
  }
}
